import { useMemo } from "react";
import type { AccessPermission } from "@entrilia/shared/api/types.ts";
import useUserContext from "../../../../../../context/useUserContext";

export function useCopyToEligibleCompanies(expectedPermissions: AccessPermission[]) {
  const { clients, permissions } = useUserContext();

  const eligibleCompanies = useMemo(() => {
    return clients.filter((c) => {
      if (c.type !== "FundManager") {
        return false;
      }
      const permissionsForClient = permissions.find((p) => p.clientCode === c.clientCode);
      return expectedPermissions.every((p) => permissionsForClient?.permissions.includes(p));
    });
  }, [clients, permissions, expectedPermissions]);

  return eligibleCompanies;
}
